import { useMutation } from '@tanstack/react-query';

import { Zone } from 'src/features/zone/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/sites/zone/`;

type MutationFnType = typeof mutationFn;
interface DTO {
    parkingId: string;
}

const mutationFn = ({ parkingId, ...data }: DTO): Promise<Zone> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateZone };
